import { logout as logoutSession, SESSION_LOGOUT_REASONS } from '@/services/auth/sessionService.js';

export const useLogout = () => {
    const logout = async () => {
        await logoutSession({ reason: SESSION_LOGOUT_REASONS.MANUAL });
    };

    return { logout };
};
